import React from 'react';
import Header from "../Layout/Header/Header";
import Footer from "../Layout/Footer/Footer";

function TermsCondition() {
  return (
    <div className="PrivacyPolicy innerBody">
    <Header />
    <div className="container">
      <div className="row">
        <div className="col mt-5 pt-4">
          <h3 className="title-text text-center">Terms & Conditions</h3> <br />
          <div className="terms_conditions">
            <ol>
              <li>  The competition is open for all puzzlers in India as well as across the world. Any incorrect/fraudulent entries will be disqualified.
              </li>

              <li>  The Organizers reserve the right to alter the terms and conditions of the Contest at their discretion without any notice.
              </li>

              <li>  In case of a tie, the player with the shorter time taken will be placed higher in the Hall of Fame.
              </li>

              <li>  Any malpractices found during the taking of the test will result in instant disqualification.
              </li>

              <li>  The decision of the Organizers will be final & indispensable regarding the winners. 
              </li>

              <li>  In case Prize Winners are from India, prizes will be dispatched from India. In case, the Prize Winners are from overseas, we will try to dispatch the prizes based on availability from their local e-commerce stores. In the worst case, where there is no availability, the prizes might be swapped to any available equivalent alternative. 
              </li>

              <li>  All images used on the levels have been designed by our in-house designing team. For photographs/images used in the levels, the copyright lies with the original copyright owner. The pictures are provided for gameplay purposes only. If any images posted here are in violation of copyright law, please contact us at team@puzzled.in and we will gladly remove the offending images immediately.
              </li>

              <li>  Disclaimer - Puzzled has taken due care to ensure that the information mentioned here is accurate. It however accepts no responsibility for any consequential incidents that may arise from errors or omissions contained herewith. This website is intended for guidance purposes only; it does not purport to be exhaustive.

              </li>
              
            </ol> 
            <br/>
          </div>
          
        </div>
      </div>
    </div>
    <Footer />
  </div>
  );
}

export default TermsCondition;